



























import Vue from "vue";
import Excellence from "@/components/contents/Excellence.vue";
import Innovation from "@/components/contents/Innovation.vue";

export default Vue.extend({
  components: {
    Excellence,
    Innovation
  },
  data: () => ({})
});
